import { hasNumericValueDependencies } from 'mathjs'

// 公共样式
export const commonStyle = {
    rotate: 0,
    opacity: 1,
}

export const commonAttr = {
    animations: [],
    events: {},
    groupStyle: {}, // 当一个组件成为 Group 的子组件时使用
    isLock: false, // 是否锁定组件
    collapseName: 'style', // 编辑组件时记录当前使用的是哪个折叠面板，再次回来时恢复上次打开的折叠面板，优化用户体验
    linkage: {
        duration: 0, // 过渡持续时间
        data: [ // 组件联动
            {
                id: '', // 联动的组件 id
                label: '', // 联动的组件名称
                event: '', // 监听事件
                style: [{ key: '', value: '' }], // 监听的事件触发时，需要改变的属性
            },
        ],
    },
}

// 编辑器左侧组件列表
const list = [
    {
        component: 'VText',
        label: '文字',
        icon: 'text',
        propValue: {
            name: '文本',
            type: 'fixed',
            content: 'TEXT',
            dataType: 'text',
            demoValue: '',
            textSize: 1,
            fontWeight: false,
            underline: false,
            wordWrap: false,
        },
        style: {
            width: 100,
            height: 24,
            fontSize: 12,
            fontWeight: 400,
            textDecoration: '',
            color: '',
            whiteSpace: 'nowrap',
        },
    },
    {
        component: 'BarCode',
        label: '条码',
        icon: 'bar-code',
        propValue: {
            url: require('@/assets/barCode.png'),
            flip: {
                horizontal: false,
                vertical: false,
            },
            name: '一维条码',
            type: 'dynamic',
            demoValue: '',
            codeType: 'code32',
            landscape: false,
        },
        style: {
            width: 150,
            height: 100,
        },
    },
    {
        component: 'QrCode',
        label: '二维码',
        icon: 'qrcode',
        propValue: {
            url: require('@/assets/qrCode.png'),
            flip: {
                horizontal: false,
                vertical: false,
            },
            name: '二维码',
            type: 'fixed',
            demoValue: '',
            codeType: 'PDF417',
        },
        style: {
            width: 150,
            height: 150,
        },
    },
    {
        component: 'VTable',
        label: '表格',
        icon: 'table',
        propValue: {
            data: [
                ['Row1', 'Row2'],
                ['', ''],
            ],
            table: {
                height: 30,
                increment: 2,
                columns: [{
                    name: 'Col1',
                    demoValue: 'table_col1',
                    dataType: 'text',
                    width: 90,
                    canEdit: false,
                }, {
                    name: 'Col2',
                    demoValue: 'table_col2',
                    dataType: 'text',
                    width: 90,
                    canEdit: false,
                }],
            },
            name: '表格',
            type: 'dynamic',
            demoValue: '',
        },
        style: {
            width: 180,
            height: 65,
            textAlign: 'center',
        },
    },
    {
        component: 'BitMap',
        label: '位图',
        icon: 'image',
        propValue: {
            url: require('@/assets/image.jpg'),
            flip: {
                horizontal: false,
                vertical: false,
            },
            name: '位图',
            type: 'fixed',
            demoValue: '',
            imageData: '',
        },
        style: {
            width: 150,
            height: 150,
        },
    },
    {
        component: 'CutLine',
        label: '切刀',
        icon: 'cut',
        propValue: {
            url: require('@/assets/fullcut.png'),
            flip: {
                horizontal: false,
                vertical: false,
            },
            name: '切刀',
            mode: 'full',
        },
        style: {
            width: 250,
            height: 18,
        },
    },
    {
        component: 'Separator',
        label: '分割线',
        icon: 'fengexian',
        propValue: {
            name: '分割线',
            char: '=',
            wide: 22,
            inlineText: '',
        },
        style: {
            height: 22,
            whiteSpace: 'nowrap',
        },
    },
    // {
    //     component: 'VButton',
    //     label: '按钮',
    //     propValue: '按钮',
    //     icon: 'button',
    //     style: {
    //         width: 100,
    //         height: 34,
    //         borderWidth: 1,
    //         borderColor: '',
    //         borderRadius: '',
    //         fontSize: '',
    //         fontWeight: 400,
    //         lineHeight: '',
    //         letterSpacing: 0,
    //         textAlign: '',
    //         color: '',
    //         backgroundColor: '',
    //     },
    // },
    // {
    //     component: 'RectShape',
    //     label: '矩形',
    //     propValue: '&nbsp;',
    //     icon: 'juxing',
    //     style: {
    //         width: 200,
    //         height: 200,
    //         fontSize: '',
    //         fontWeight: 400,
    //         lineHeight: '',
    //         letterSpacing: 0,
    //         textAlign: 'center',
    //         color: '',
    //         borderColor: '#000',
    //         borderWidth: 1,
    //         backgroundColor: '',
    //         borderStyle: 'solid',
    //         borderRadius: '',
    //         verticalAlign: 'middle',
    //     },
    // },
    // {
    //     component: 'CircleShape',
    //     label: '圆形',
    //     propValue: '&nbsp;',
    //     icon: '24gl-circle',
    //     style: {
    //         width: 200,
    //         height: 200,
    //         fontSize: '',
    //         fontWeight: 400,
    //         lineHeight: '',
    //         letterSpacing: 0,
    //         textAlign: 'center',
    //         color: '',
    //         borderColor: '#000',
    //         borderWidth: 1,
    //         backgroundColor: '',
    //         borderStyle: 'solid',
    //         borderRadius: '',
    //         verticalAlign: 'middle',
    //     },
    // },
    // {
    //     component: 'SVGStar',
    //     label: '星形',
    //     icon: 'kongwujiaoxing',
    //     propValue: '',
    //     style: {
    //         width: 80,
    //         height: 80,
    //         fontSize: '',
    //         fontWeight: 400,
    //         lineHeight: '',
    //         letterSpacing: 0,
    //         textAlign: 'center',
    //         color: '',
    //         borderColor: '#000',
    //         backgroundColor: 'rgba(255, 255, 255, 1)',
    //     },
    // },
    // {
    //     component: 'SVGTriangle',
    //     label: '三角形',
    //     icon: 'xingzhuang-sanjiaoxing',
    //     propValue: '',
    //     style: {
    //         width: 80,
    //         height: 80,
    //         fontSize: '',
    //         fontWeight: 400,
    //         lineHeight: '',
    //         letterSpacing: 0,
    //         textAlign: 'center',
    //         color: '',
    //         borderColor: '#000',
    //         backgroundColor: 'rgba(255, 255, 255, 1)',
    //     },
    // },
]

for (let i = 0, len = list.length; i < len; i++) {
    const item = list[i]
    item.style = { ...commonStyle, ...item.style }
    list[i] = { ...commonAttr, ...item }
}

export default list
